import { handleButtonTracking } from "./button-tracking";

export const handleScroll = async (hash) => {
  const element = document.getElementById(hash);
  console.log(hash);
  if (element) {
    const offset = 25;

    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementPosition - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};

/**
 * Smoothly scroll to an in-page anchor, then re-correct after a beat.
 * The re-correction matters because below-the-fold images finish loading
 * after the initial scroll and push the target section, which otherwise
 * leaves the nav landing in the wrong place.
 */
export const scrollToHash = (hash: string, offset = 25) => {
  // Absolute document position of the target (invariant to current scroll),
  // so it only changes if the page layout actually shifts.
  const targetFor = () => {
    const element = document.getElementById(hash);
    if (!element) return null;
    return element.getBoundingClientRect().top + window.scrollY - offset;
  };

  const initial = targetFor();
  if (initial == null) return;
  let target: number = initial;
  window.scrollTo({ top: target, behavior: "smooth" });

  // If below-the-fold images load in and move the section, re-aim smoothly.
  // We compare against the previous *target*, not the live scroll position,
  // so we never interrupt the in-progress smooth scroll when nothing shifted.
  [350, 750].forEach((delay) =>
    setTimeout(() => {
      const next = targetFor();
      if (next != null && Math.abs(next - target) > 4) {
        target = next;
        window.scrollTo({ top: next, behavior: "smooth" });
      }
    }, delay),
  );
};

export const handleHeaderClick = async (_router, hash) => {
  handleButtonTracking(`clicked_${hash}_nav`);
  // Off the homepage, do a full navigation so the target section exists.
  if (window.location.pathname !== "/") {
    window.location.href = `/#${hash}`;
    return;
  }
  // On the homepage, update the hash without a Next soft-navigation, then scroll.
  history.replaceState(null, "", `/#${hash}`);
  scrollToHash(hash);
};

export const handleBlogScroll = async (hash) => {
  const element = document.getElementById(hash);
  if (element) {
    const offset = 75;

    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementPosition - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};
